import React from 'react';

import dynamic from 'next/dynamic';
import { twMerge } from 'tailwind-merge';

import { IBoundary } from '../../helpers/hooks/fishrules/useRegulationBoundaryAtLocation';
import { ICoordinates } from '../../interfaces/geo';
import { Heading } from '../Heading/Heading';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

import { RegulationLocationContent } from './RegulationLocationContent';

interface ICoordinateProps {
  coordinates: ICoordinates | undefined;
  boundaryName: string | undefined;
  boundaries: IBoundary[] | undefined;
  isLoadingBoundaries?: boolean;
  fishrulesSpeciesId: number | undefined;
  className?: string;
}

const DynamicChangeLocation = dynamic(
  async () => import('../ChangeLocation/ChangeLocation').then(mod => mod.ChangeLocation),
  { ssr: false },
);

export const RegulationLocationCard = ({
  coordinates,
  boundaryName,
  boundaries,
  isLoadingBoundaries,
  fishrulesSpeciesId,
  className,
}: ICoordinateProps) => (
  <div
    className={twMerge(
      `flex flex-col justify-between rounded-md bg-white sm:flex-row sm:items-center`,
      className,
    )}
  >
    {isLoadingBoundaries ? (
      <LoadingSpinner className="m-0 w-full p-4" loadingText="Loading boundaries..." />
    ) : (
      <>
        {boundaries && (
          <>
            <div className="p-4 md:p-8">
              <Heading variant="2xs">Regulations for</Heading>
              <RegulationLocationContent
                coordinates={coordinates}
                boundaryName={boundaryName}
                boundaries={boundaries}
              />
            </div>
            <DynamicChangeLocation
              coordinates={coordinates!}
              fishrulesSpeciesId={fishrulesSpeciesId}
              eventSource="regulation-location"
            />
          </>
        )}
      </>
    )}
  </div>
);
